/**
 * Dev-only preview for Phase 0 shadcn foundation.
 * Rendered on Dashboard in dev only (`isDev` from `@/shared/lib/config`).
 */
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function ShadcnFoundationPreview() {
  return (
    <TooltipProvider>
      <Card className="border-dashed border-mineral-gold/40">
        <CardHeader>
          <div className="flex items-center gap-2">
            <CardTitle className="text-base">shadcn Foundation (dev)</CardTitle>
            <Badge variant="secondary">Phase 0</Badge>
          </div>
          <CardDescription>
            Local components จาก <code>@/components/ui</code> — ยังไม่แทน devhop
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex flex-wrap gap-2">
            <Button type="button">Primary</Button>
            <Button type="button" variant="outline">
              Outline
            </Button>
            <Button type="button" variant="secondary">
              Secondary
            </Button>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button type="button" variant="ghost">
                  Tooltip
                </Button>
              </TooltipTrigger>
              <TooltipContent>shadcn tooltip ทำงาน</TooltipContent>
            </Tooltip>
          </div>

          <Separator />

          <div className="grid max-w-sm gap-2">
            <Label htmlFor="shadcn-smoke-input">Input</Label>
            <Input id="shadcn-smoke-input" placeholder="Mineral Admin" />
          </div>

          <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-24" />
            <span className="text-muted-foreground text-xs">Skeleton</span>
          </div>
        </CardContent>
      </Card>
    </TooltipProvider>
  );
}
